export const CONFLUENCE_PAGE_AI_SNIPPET_OPERATION_NAME = 'KnowledgeDiscoveryAiSnippetQuery';

export const KnowledgeDiscoveryAiSnippetQuery = `
query KnowledgeDiscoveryAiSnippetQuery($cloudId: ID!, $id: ID!) {
  singleContent(cloudId: $cloudId, id: $id) {
    aiProperty(objectType: snippet_v2) {
      objectData
    }
  }
}
`;
